import { HttpService, Repository, RepositoryBase, RepositorySaveResponse, TaggedUrl, Tags, Weaver } from '@skylab-shared/core';
import { MailTemplateModel } from '@skylab-shared/dataModel';
import { pickBy, ResponseUtils } from '@skylab-shared/utils';
import { FlagChangeResponse } from '../common/flag-change-response';
import { MailTemplateBO } from './mail-template.bo';

@Repository({
    boType: MailTemplateBO,
    apiController: TaggedUrl.join('system/emailPatterns', [Tags.Api])
})
export class MailTemplateRepositoryBase extends RepositoryBase<MailTemplateBO, MailTemplateModel> {
    public constructor(
        private readonly http: HttpService,
        private readonly weaver: Weaver) {
        super(http);
    }

    protected createBO(): MailTemplateBO {
        return new MailTemplateBO(this.weaver);
    }

    protected async fromPlainObjectAsync(item: any): Promise<MailTemplateModel> {
        const model = new MailTemplateModel(pickBy({
            default: item.default,
            id: item.id,
            kind: item.kind,
            messagePattern: item.messagePattern,
            name: item.name,
            senderName: item.senderName,
            subjectPattern: item.subjectPattern,
            sun: item.sun,
            version: item.version
        }, val => val !== void 0));

        return model;
    }

    protected async preparePlainObjectAsync(model: MailTemplateModel): Promise<any> {
        return {
            id: model.id,
            default: model.default,
            kind: model.kind,
            name: model.name,
            senderName: model.senderName,
            subjectPattern: model.subjectPattern,
            messagePattern: model.messagePattern,
            version: model.version
        };
    }

    public async setAsDefaultAsync(templateType: string, id: number): Promise<FlagChangeResponse | void> {
        try {
            const response = await this.http.sendRequest({
                method: 'PUT',
                url: `[api] system/emailPatterns/${templateType}/default`,
                params: { id: id }
            });
            if (ResponseUtils.isStatusSuccess(response.status)) {
                const successData: RepositorySaveResponse = response.data;
                return {
                    value: true,
                    id: successData.object?.id,
                    version: successData.object?.version
                };
            }
        } catch (err) {
            this.logger.error(err);
        }
    }
}
